// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utility Classes for Mobile-First Design */

/* Mobile-First Container */
.container-mobile {
  width: 100%;
  padding-left: var(--content-padding-mobile);
  padding-right: var(--content-padding-mobile);
}

@media (min-width: 992px) {
  .container-mobile {
    padding-left: var(--content-padding-desktop);
    padding-right: var(--content-padding-desktop);
  }
}

/* Mobile Stack - Vertical on mobile, horizontal on desktop */
.stack-mobile {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .stack-mobile {
    flex-direction: row;
  }
}

/* Touch-Friendly Button */
.btn-touch {
  min-height: var(--touch-target-min);
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-base);
}

/* Mobile Display Utilities */
.d-mobile-none {
  display: none !important;
}

@media (min-width: 768px) {
  .d-mobile-none {
    display: block !important;
  }
}

.d-mobile-block {
  display: block !important;
}

@media (min-width: 768px) {
  .d-mobile-block {
    display: none !important;
  }
}

.d-desktop-none {
  display: block !important;
}

@media (min-width: 768px) {
  .d-desktop-none {
    display: none !important;
  }
}

.d-desktop-block {
  display: none !important;
}

@media (min-width: 768px) {
  .d-desktop-block {
    display: block !important;
  }
}

/* Mobile Text Utilities */
.text-mobile-sm {
  font-size: var(--font-size-sm);
}

@media (min-width: 768px) {
  .text-mobile-sm {
    font-size: var(--font-size-base);
  }
}

.text-mobile-center {
  text-align: center;
}

@media (min-width: 768px) {
  .text-mobile-center {
    text-align: left;
  }
}

.text-truncate-mobile {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Mobile Spacing Utilities */
.mb-mobile {
  margin-bottom: var(--spacing-md);
}

@media (min-width: 768px) {
  .mb-mobile {
    margin-bottom: var(--spacing-lg);
  }
}

.p-mobile {
  padding: var(--spacing-md);
}

@media (min-width: 768px) {
  .p-mobile {
    padding: var(--spacing-lg);
  }
}

.gap-mobile {
  gap: var(--spacing-sm);
}

@media (min-width: 768px) {
  .gap-mobile {
    gap: var(--spacing-md);
  }
}

/* Mobile Table to Card Conversion */
@media (max-width: 767.98px) {
  .table-mobile-card {
    display: block;
  }
  
  .table-mobile-card thead {
    display: none;
  }
  
  .table-mobile-card tbody,
  .table-mobile-card tr,
  .table-mobile-card td {
    display: block;
    width: 100%;
  }
  
  .table-mobile-card tr {
    margin-bottom: var(--spacing-md);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-md);
    padding: var(--spacing-md);
    background-color: var(--bg-white);
  }
  
  .table-mobile-card td {
    border: none;
    padding: var(--spacing-sm) 0;
    text-align: left;
    position: relative;
    padding-left: 40%;
    min-height: 2rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .table-mobile-card td:before {
    content: attr(data-label);
    font-weight: 600;
    position: absolute;
    left: 0;
    width: 35%;
    padding-right: var(--spacing-sm);
    color: var(--text-secondary);
    top: var(--spacing-sm);
    line-height: 1.4;
  }
  
  .table-mobile-card td:last-child {
    padding-left: 0;
    margin-top: var(--spacing-md);
    padding-top: var(--spacing-md);
    border-top: 1px solid var(--border-color-light);
    min-height: auto;
  }
  
  .table-mobile-card td:last-child:before {
    display: none;
  }
  
  /* Ensure badges and wrapping content don't overflow */
  .table-mobile-card td > div {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .table-mobile-card td .badge {
    display: inline-block;
    margin-bottom: var(--spacing-xs);
    word-wrap: break-word;
    max-width: 100%;
  }
}

/* Full width on mobile */
.w-mobile-100 {
  width: 100%;
}

@media (min-width: 768px) {
  .w-mobile-100 {
    width: auto;
  }
}

/* Stack buttons vertically on mobile */
.buttons-stack-mobile {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

@media (min-width: 768px) {
  .buttons-stack-mobile {
    flex-direction: row;
    gap: var(--spacing-sm);
  }
}

/* Header stack on mobile */
.header-stack-mobile {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .header-stack-mobile {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacing-md);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/utilities.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C,2BAA2B;AAC3B;EACE,WAAW;EACX,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE;IACE,4CAA4C;IAC5C,6CAA6C;EAC/C;AACF;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,qCAAqC;IACrC,sCAAsC;IACtC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,gCAAgC;IAChC,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,+CAA+C;IAC/C,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,gCAAgC;IAChC,qBAAqB;IACrB,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;EACxB;AACF","sourcesContent":["/* Utility Classes for Mobile-First Design */\n\n/* Mobile-First Container */\n.container-mobile {\n  width: 100%;\n  padding-left: var(--content-padding-mobile);\n  padding-right: var(--content-padding-mobile);\n}\n\n@media (min-width: 992px) {\n  .container-mobile {\n    padding-left: var(--content-padding-desktop);\n    padding-right: var(--content-padding-desktop);\n  }\n}\n\n/* Mobile Stack - Vertical on mobile, horizontal on desktop */\n.stack-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n@media (min-width: 768px) {\n  .stack-mobile {\n    flex-direction: row;\n  }\n}\n\n/* Touch-Friendly Button */\n.btn-touch {\n  min-height: var(--touch-target-min);\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-base);\n}\n\n/* Mobile Display Utilities */\n.d-mobile-none {\n  display: none !important;\n}\n\n@media (min-width: 768px) {\n  .d-mobile-none {\n    display: block !important;\n  }\n}\n\n.d-mobile-block {\n  display: block !important;\n}\n\n@media (min-width: 768px) {\n  .d-mobile-block {\n    display: none !important;\n  }\n}\n\n.d-desktop-none {\n  display: block !important;\n}\n\n@media (min-width: 768px) {\n  .d-desktop-none {\n    display: none !important;\n  }\n}\n\n.d-desktop-block {\n  display: none !important;\n}\n\n@media (min-width: 768px) {\n  .d-desktop-block {\n    display: block !important;\n  }\n}\n\n/* Mobile Text Utilities */\n.text-mobile-sm {\n  font-size: var(--font-size-sm);\n}\n\n@media (min-width: 768px) {\n  .text-mobile-sm {\n    font-size: var(--font-size-base);\n  }\n}\n\n.text-mobile-center {\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n  .text-mobile-center {\n    text-align: left;\n  }\n}\n\n.text-truncate-mobile {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Mobile Spacing Utilities */\n.mb-mobile {\n  margin-bottom: var(--spacing-md);\n}\n\n@media (min-width: 768px) {\n  .mb-mobile {\n    margin-bottom: var(--spacing-lg);\n  }\n}\n\n.p-mobile {\n  padding: var(--spacing-md);\n}\n\n@media (min-width: 768px) {\n  .p-mobile {\n    padding: var(--spacing-lg);\n  }\n}\n\n.gap-mobile {\n  gap: var(--spacing-sm);\n}\n\n@media (min-width: 768px) {\n  .gap-mobile {\n    gap: var(--spacing-md);\n  }\n}\n\n/* Mobile Table to Card Conversion */\n@media (max-width: 767.98px) {\n  .table-mobile-card {\n    display: block;\n  }\n  \n  .table-mobile-card thead {\n    display: none;\n  }\n  \n  .table-mobile-card tbody,\n  .table-mobile-card tr,\n  .table-mobile-card td {\n    display: block;\n    width: 100%;\n  }\n  \n  .table-mobile-card tr {\n    margin-bottom: var(--spacing-md);\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius-md);\n    padding: var(--spacing-md);\n    background-color: var(--bg-white);\n  }\n  \n  .table-mobile-card td {\n    border: none;\n    padding: var(--spacing-sm) 0;\n    text-align: left;\n    position: relative;\n    padding-left: 40%;\n    min-height: 2rem;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  \n  .table-mobile-card td:before {\n    content: attr(data-label);\n    font-weight: 600;\n    position: absolute;\n    left: 0;\n    width: 35%;\n    padding-right: var(--spacing-sm);\n    color: var(--text-secondary);\n    top: var(--spacing-sm);\n    line-height: 1.4;\n  }\n  \n  .table-mobile-card td:last-child {\n    padding-left: 0;\n    margin-top: var(--spacing-md);\n    padding-top: var(--spacing-md);\n    border-top: 1px solid var(--border-color-light);\n    min-height: auto;\n  }\n  \n  .table-mobile-card td:last-child:before {\n    display: none;\n  }\n  \n  /* Ensure badges and wrapping content don't overflow */\n  .table-mobile-card td > div {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  \n  .table-mobile-card td .badge {\n    display: inline-block;\n    margin-bottom: var(--spacing-xs);\n    word-wrap: break-word;\n    max-width: 100%;\n  }\n}\n\n/* Full width on mobile */\n.w-mobile-100 {\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .w-mobile-100 {\n    width: auto;\n  }\n}\n\n/* Stack buttons vertically on mobile */\n.buttons-stack-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n@media (min-width: 768px) {\n  .buttons-stack-mobile {\n    flex-direction: row;\n    gap: var(--spacing-sm);\n  }\n}\n\n/* Header stack on mobile */\n.header-stack-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n@media (min-width: 768px) {\n  .header-stack-mobile {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--spacing-md);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
